export default "__VITE_ASSET__a45b6659__"